import React, { FC, useEffect } from "react";
import { User } from "../../types/userTypes";
import { Form, Input } from "antd";
import SafeAction from "../common/SafeAction";
import { NotificationType, notify } from "../../utils/helpers";
import { api } from "../../api/api";

type Props = {
  user: User;
}

const GiveAccessToCoach: FC<Props> = ({ user }: Props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (user) {
      form.resetFields();
    }
  }, [user]);

  return (
    <Form
      form={form}
      style={{ display: 'flex', flexDirection: 'row', gap: '15px' }}
      initialValues={{ accessCode: '' }}
    >
      <Form.Item style={{ width: '100%' }} name='accessCode' label={"Coach Access Code"} rules={[{ required: true, min: 8, max: 8 }]}>
        <Input placeholder={"Enter Coach Access Code"} />
      </Form.Item>
      <SafeAction
        title={'Save'}
        onError={(message: string) => notify(message)}
        action={() => form
          .validateFields()
          .then(async values => {
            const res = await api.assignCoach(user?.id!, values.accessCode);
            if (res.ok) {
              notify("Coach assigned", NotificationType.SUCCESS);
            }
            return res;
          })
          .catch(info => {
            console.log('Validate Failed:', info);
            return { ok: false, data: { message: 'Invalid access code format' } }
          })

        }
        doneText={'Coach is successfully assigned'}
      />
    </Form>
  )
}

export default GiveAccessToCoach;